import React from 'react';

const SocialIcons = () => {
  return (
    <div className="social-icons animate-icons">
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/"><i className="fa fa-github"></i></a>
        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/"><i className="fa fa-linkedin"></i></a>
      </div>
  );
};

export default SocialIcons;


// WEBPACK FOOTER //
// ./src/components/socialIcons/SocialIcons.jsx